const container = 'section.error-page'

export default {
  header: `${container} > .error-page__header`,
  errors: `${container} > .error-page__details li`
}
